import { showBedrooms, showRooms } from "@Utils/Functions";
import { useContext } from "react";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

//Esto es solo para el header de filtros. cambiar por un nombre más acorde
export const useHideFiltersLogic = () => {
  const { country_code } = useContext(ConfigStateContext);
  const {filtersTags, filters} = useFilters();
  const isRooms = showRooms(filters?.property_type_id, filters?.operation_type_id, country_code);
	const isBedrooms = showBedrooms(filters?.property_type_id, filters?.operation_type_id, country_code);
  
  return {
    hideBedrooms: (!isRooms && !isBedrooms) || (filtersTags?.operation_type_id?.value === 4),
    hideGarage: (filtersTags?.property_type_id?.length === 1 && [3,8].includes(filtersTags?.property_type_id[0].value)) || (filtersTags?.operation_type_id?.value === 4),
    hideM2land: filtersTags?.property_type_id?.length !== 1 || (filtersTags?.property_type_id[0].value !== 3),
    hideGuests: !filtersTags?.operation_type_id || filtersTags?.operation_type_id?.value !== 4,
    hideDates: !filtersTags?.operation_type_id || filtersTags?.operation_type_id?.value !== 4,
  };
};
